import { render, staticRenderFns } from "./Aproblemdetail.vue?vue&type=template&id=c6d89654&scoped=true"
import script from "./Aproblemdetail.vue?vue&type=script&lang=js"
export * from "./Aproblemdetail.vue?vue&type=script&lang=js"
import style0 from "./Aproblemdetail.vue?vue&type=style&index=0&id=c6d89654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d89654",
  null
  
)

export default component.exports